// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-gallery-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
}

.image-gallery-container h2 {
    text-align: center;
    color: #333;
    margin-bottom: 30px;
}

.image-card {
    height: 100%;
    overflow: hidden;
}

.image-card-content {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.image-container {
    position: relative;
    width: 100%;
    height: 200px;
    overflow: hidden; /* Importante: esconde o que extrapola */
    background-color: #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Arquivo CSS separado */
.image-gallery-container .p-card {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.image-gallery-container .p-card-body {
    flex: 1 1;
    display: flex;
    flex-direction: column;
}

.image-gallery-container img {
    max-width: 100%;
    height: auto;
    display: block;
}

/* Seletor de Pasta */
.folder-selector {
    margin-bottom: 30px;
    text-align: center;
}

.folder-selector label {
    display: block;
    margin-bottom: 10px;
    font-weight: 600;
    color: #555;
}

.folder-select {
    width: 300px;
    padding: 10px 15px;
    font-size: 16px;
    border: 2px solid #ddd;
    border-radius: 8px;
    background-color: white;
    cursor: pointer;
    transition: border-color 0.3s;
}

.folder-select:hover {
    border-color: #007bff;
}

.folder-select:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

/* Alertas */
.alert {
    padding: 12px 20px;
    margin: 20px 0;
    border-radius: 8px;
    text-align: center;
    animation: slideIn 0.3s ease;
}

.alert-error {
    background-color: #fee;
    color: #c33;
    border: 1px solid #fcc;
}

.alert-success {
    background-color: #efe;
    color: #3c3;
    border: 1px solid #cfc;
}

/* Seção de Upload */
.upload-section {
    background: #f8f9fa;
    padding: 25px;
    border-radius: 12px;
    margin-bottom: 30px;
}

.upload-section h3 {
    margin-bottom: 20px;
    color: #333;
}

.upload-area {
    text-align: center;
}

.select-files-btn {
    padding: 12px 30px;
    font-size: 16px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s;
}

.select-files-btn:hover {
    background-color: #0056b3;
    transform: translateY(-2px);
}

.select-files-btn:disabled {
    background-color: #ccc;
    cursor: not-allowed;
    transform: none;
}

/* Preview de Arquivos Selecionados */
.selected-files-preview {
    margin-top: 20px;
}

.selected-files-preview h4 {
    margin-bottom: 15px;
    color: #555;
}

.preview-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    grid-gap: 15px;
    gap: 15px;
    margin-bottom: 20px;
}

.preview-item {
    position: relative;
    border: 2px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
    background: white;
}

.preview-item img {
    width: 100%;
    height: 120px;
    object-fit: cover;
}

.preview-info {
    padding: 8px;
    font-size: 12px;
}

.file-name {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
}

.file-size {
    color: #666;
}

.remove-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    background: rgba(255, 255, 255, 0.9);
    border: none;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
}

.remove-btn:hover {
    background: #ff4444;
    color: white;
}

.upload-btn {
    padding: 12px 40px;
    font-size: 16px;
    background-color: #28a745;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s;
}

.upload-btn:hover {
    background-color: #218838;
}

.upload-btn:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

/* Seção da Galeria */
.gallery-section {
    margin-top: 40px;
}

.gallery-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 10px;
}

.gallery-header h3 {
    color: #333;
    margin: 0;
}

.gallery-actions {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.selection-mode-btn,
.select-all-btn,
.delete-selected-btn {
    padding: 8px 16px;
    font-size: 14px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    gap: 5px;
}

.selection-mode-btn {
    background-color: #6c757d;
    color: white;
}

.selection-mode-btn.active {
    background-color: #007bff;
}

.selection-mode-btn:hover {
    background-color: #5a6268;
}

.selection-mode-btn.active:hover {
    background-color: #0056b3;
}

.select-all-btn {
    background-color: #17a2b8;
    color: white;
}

.select-all-btn:hover {
    background-color: #138496;
}

.delete-selected-btn {
    background-color: #dc3545;
    color: white;
}

.delete-selected-btn:hover {
    background-color: #c82333;
}

.delete-selected-btn:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

/* Grid da Galeria */
.gallery-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    grid-gap: 20px;
    gap: 20px;
}

.gallery-item {
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.gallery-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
}

.gallery-item.selected {
    border: 3px solid #007bff;
    transform: scale(0.95);
}

.gallery-item img {
    width: 100%;
    height: 200px;
    object-fit: cover;
    display: block;
}

.selection-overlay {
    position: absolute;
    top: 10px;
    left: 10px;
    background: white;
    border-radius: 4px;
    padding: 2px;
}

.selection-overlay input[type="checkbox"] {
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s;
}

.gallery-item:hover .image-overlay {
    opacity: 1;
}

.delete-single-btn {
    background: #dc3545;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 16px;
    transition: all 0.3s;
}

.delete-single-btn:hover {
    background: #c82333;
    transform: scale(1.1);
}

.image-info {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 8px;
    font-size: 14px;
    text-align: center;
}

/* Loading e Empty States */
.loading-spinner,
.empty-gallery {
    text-align: center;
    padding: 60px 20px;
    color: #666;
}

.loading-spinner i,
.empty-gallery i {
    font-size: 48px;
    margin-bottom: 20px;
    display: block;
}

/* Animações */
@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Responsividade */
@media (max-width: 768px) {
    .folder-select {
        width: 100%;
    }
    
    .gallery-header {
        flex-direction: column;
        align-items: flex-start;
    }
    
    .gallery-actions {
        width: 100%;
        justify-content: flex-start;
    }
    
    .gallery-grid {
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
        gap: 10px;
    }
    
    .gallery-item img {
        height: 150px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Imagem/imageGallery.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB,EAAE,wCAAwC;IAC1D,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,yBAAyB;AACzB;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA,YAAY;AACZ;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,sBAAsB;AAC1B;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;AACnB;;AAEA,qCAAqC;AACrC;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,cAAS;IAAT,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,oCAAoC;IACpC,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;;;IAGI,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,4DAA4D;IAC5D,cAAS;IAAT,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,wCAAwC;AAC5C;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,8BAA8B;IAC9B,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA,2BAA2B;AAC3B;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;;IAEI,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA,cAAc;AACd;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,2BAA2B;IAC/B;;IAEA;QACI,4DAA4D;QAC5D,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".image-gallery-container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px;\n}\n\n.image-gallery-container h2 {\n    text-align: center;\n    color: #333;\n    margin-bottom: 30px;\n}\n\n.image-card {\n    height: 100%;\n    overflow: hidden;\n}\n\n.image-card-content {\n    position: relative;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.image-container {\n    position: relative;\n    width: 100%;\n    height: 200px;\n    overflow: hidden; /* Importante: esconde o que extrapola */\n    background-color: #f0f0f0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n/* Arquivo CSS separado */\n.image-gallery-container .p-card {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.image-gallery-container .p-card-body {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n}\n\n.image-gallery-container img {\n    max-width: 100%;\n    height: auto;\n    display: block;\n}\n\n/* Seletor de Pasta */\n.folder-selector {\n    margin-bottom: 30px;\n    text-align: center;\n}\n\n.folder-selector label {\n    display: block;\n    margin-bottom: 10px;\n    font-weight: 600;\n    color: #555;\n}\n\n.folder-select {\n    width: 300px;\n    padding: 10px 15px;\n    font-size: 16px;\n    border: 2px solid #ddd;\n    border-radius: 8px;\n    background-color: white;\n    cursor: pointer;\n    transition: border-color 0.3s;\n}\n\n.folder-select:hover {\n    border-color: #007bff;\n}\n\n.folder-select:focus {\n    outline: none;\n    border-color: #007bff;\n    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n}\n\n/* Alertas */\n.alert {\n    padding: 12px 20px;\n    margin: 20px 0;\n    border-radius: 8px;\n    text-align: center;\n    animation: slideIn 0.3s ease;\n}\n\n.alert-error {\n    background-color: #fee;\n    color: #c33;\n    border: 1px solid #fcc;\n}\n\n.alert-success {\n    background-color: #efe;\n    color: #3c3;\n    border: 1px solid #cfc;\n}\n\n/* Seção de Upload */\n.upload-section {\n    background: #f8f9fa;\n    padding: 25px;\n    border-radius: 12px;\n    margin-bottom: 30px;\n}\n\n.upload-section h3 {\n    margin-bottom: 20px;\n    color: #333;\n}\n\n.upload-area {\n    text-align: center;\n}\n\n.select-files-btn {\n    padding: 12px 30px;\n    font-size: 16px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.3s;\n}\n\n.select-files-btn:hover {\n    background-color: #0056b3;\n    transform: translateY(-2px);\n}\n\n.select-files-btn:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n    transform: none;\n}\n\n/* Preview de Arquivos Selecionados */\n.selected-files-preview {\n    margin-top: 20px;\n}\n\n.selected-files-preview h4 {\n    margin-bottom: 15px;\n    color: #555;\n}\n\n.preview-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n    gap: 15px;\n    margin-bottom: 20px;\n}\n\n.preview-item {\n    position: relative;\n    border: 2px solid #ddd;\n    border-radius: 8px;\n    overflow: hidden;\n    background: white;\n}\n\n.preview-item img {\n    width: 100%;\n    height: 120px;\n    object-fit: cover;\n}\n\n.preview-info {\n    padding: 8px;\n    font-size: 12px;\n}\n\n.file-name {\n    display: block;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-weight: 500;\n}\n\n.file-size {\n    color: #666;\n}\n\n.remove-btn {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    background: rgba(255, 255, 255, 0.9);\n    border: none;\n    border-radius: 50%;\n    width: 25px;\n    height: 25px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.3s;\n}\n\n.remove-btn:hover {\n    background: #ff4444;\n    color: white;\n}\n\n.upload-btn {\n    padding: 12px 40px;\n    font-size: 16px;\n    background-color: #28a745;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.3s;\n}\n\n.upload-btn:hover {\n    background-color: #218838;\n}\n\n.upload-btn:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n}\n\n/* Seção da Galeria */\n.gallery-section {\n    margin-top: 40px;\n}\n\n.gallery-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n\n.gallery-header h3 {\n    color: #333;\n    margin: 0;\n}\n\n.gallery-actions {\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.selection-mode-btn,\n.select-all-btn,\n.delete-selected-btn {\n    padding: 8px 16px;\n    font-size: 14px;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.3s;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.selection-mode-btn {\n    background-color: #6c757d;\n    color: white;\n}\n\n.selection-mode-btn.active {\n    background-color: #007bff;\n}\n\n.selection-mode-btn:hover {\n    background-color: #5a6268;\n}\n\n.selection-mode-btn.active:hover {\n    background-color: #0056b3;\n}\n\n.select-all-btn {\n    background-color: #17a2b8;\n    color: white;\n}\n\n.select-all-btn:hover {\n    background-color: #138496;\n}\n\n.delete-selected-btn {\n    background-color: #dc3545;\n    color: white;\n}\n\n.delete-selected-btn:hover {\n    background-color: #c82333;\n}\n\n.delete-selected-btn:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n}\n\n/* Grid da Galeria */\n.gallery-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 20px;\n}\n\n.gallery-item {\n    position: relative;\n    border-radius: 8px;\n    overflow: hidden;\n    cursor: pointer;\n    transition: all 0.3s;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.gallery-item:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);\n}\n\n.gallery-item.selected {\n    border: 3px solid #007bff;\n    transform: scale(0.95);\n}\n\n.gallery-item img {\n    width: 100%;\n    height: 200px;\n    object-fit: cover;\n    display: block;\n}\n\n.selection-overlay {\n    position: absolute;\n    top: 10px;\n    left: 10px;\n    background: white;\n    border-radius: 4px;\n    padding: 2px;\n}\n\n.selection-overlay input[type=\"checkbox\"] {\n    width: 20px;\n    height: 20px;\n    cursor: pointer;\n}\n\n.image-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.7);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    opacity: 0;\n    transition: opacity 0.3s;\n}\n\n.gallery-item:hover .image-overlay {\n    opacity: 1;\n}\n\n.delete-single-btn {\n    background: #dc3545;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 16px;\n    transition: all 0.3s;\n}\n\n.delete-single-btn:hover {\n    background: #c82333;\n    transform: scale(1.1);\n}\n\n.image-info {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: rgba(0, 0, 0, 0.8);\n    color: white;\n    padding: 8px;\n    font-size: 14px;\n    text-align: center;\n}\n\n/* Loading e Empty States */\n.loading-spinner,\n.empty-gallery {\n    text-align: center;\n    padding: 60px 20px;\n    color: #666;\n}\n\n.loading-spinner i,\n.empty-gallery i {\n    font-size: 48px;\n    margin-bottom: 20px;\n    display: block;\n}\n\n/* Animações */\n@keyframes slideIn {\n    from {\n        opacity: 0;\n        transform: translateY(-10px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Responsividade */\n@media (max-width: 768px) {\n    .folder-select {\n        width: 100%;\n    }\n    \n    .gallery-header {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n    \n    .gallery-actions {\n        width: 100%;\n        justify-content: flex-start;\n    }\n    \n    .gallery-grid {\n        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n        gap: 10px;\n    }\n    \n    .gallery-item img {\n        height: 150px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
